export default __webpack_public_path__ + "static/media/waterFr.7d3ffb84.jpg";